module.exports = __webpack_public_path__ + "img/app-store.53678d46.png";